const CACHE_KEY_PREFIX = 'urunn_subscription_';
const CACHE_DURATION = 1000 * 60 * 5; // 5 minutes

interface SubscriptionCacheData {
  details: any;
  timestamp: number;
}

/**
 * Save subscription details to cache
 */
export const saveSubscriptionToCache = (userId: string, details: any): void => {
  try {
    const cacheData: SubscriptionCacheData = {
      details,
      timestamp: Date.now(),
    };
    localStorage.setItem(`${CACHE_KEY_PREFIX}${userId}`, JSON.stringify(cacheData));
    console.log('Subscription cached successfully for user:', userId);
  } catch (error) {
    console.warn('Failed to cache subscription:', error);
  }
};

/**
 * Get subscription details from cache if valid
 */
export const getSubscriptionFromCache = (userId: string): any | null => {
  try {
    const cached = localStorage.getItem(`${CACHE_KEY_PREFIX}${userId}`);
    if (!cached) {
      console.log('No cached subscription found for user:', userId);
      return null;
    }

    const cacheData: SubscriptionCacheData = JSON.parse(cached);
    const age = Date.now() - cacheData.timestamp;

    if (age > CACHE_DURATION) {
      console.log('Cached subscription expired for user:', userId, '(age:', Math.round(age / 1000), 'seconds)');
      clearSubscriptionCache(userId);
      return null;
    }

    console.log('Using cached subscription for user:', userId, '(age:', Math.round(age / 1000), 'seconds)');
    return cacheData.details;
  } catch (error) {
    console.warn('Failed to read subscription from cache:', error);
    clearSubscriptionCache(userId);
    return null;
  }
};

/**
 * Clear subscription cache for a user
 */
export const clearSubscriptionCache = (userId: string): void => {
  try {
    localStorage.removeItem(`${CACHE_KEY_PREFIX}${userId}`);
    console.log('Subscription cache cleared for user:', userId);
  } catch (error) {
    console.warn('Failed to clear subscription cache:', error);
  }
};

/**
 * Clear all subscription caches
 */
export const clearAllSubscriptionCaches = (): void => {
  try {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(CACHE_KEY_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
    console.log('All subscription caches cleared');
  } catch (error) {
    console.warn('Failed to clear all subscription caches:', error);
  }
};
